var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideoCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.833,
    height: 21.689,
    viewBox: "0 0 33.833 21.689",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#666;stroke:#666;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M32.493,1.845a.7.7,0,0,0-.689-.012L24.271,5.946V3.478A3.482,3.482,0,0,0,20.793,0H3.479A3.482,3.482,0,0,0,0,3.478V17.211a3.482,3.482,0,0,0,3.478,3.478H20.793a3.482,3.482,0,0,0,3.478-3.478V14.788L31.8,18.9a.7.7,0,0,0,1.029-.611V2.443a.7.7,0,0,0-.341-.6ZM22.88,17.211A2.089,2.089,0,0,1,20.793,19.3H3.479a2.089,2.089,0,0,1-2.087-2.087V3.478A2.089,2.089,0,0,1,3.479,1.391H20.793A2.09,2.09,0,0,1,22.88,3.478Zm8.563-.093L24.271,13.2V7.531l7.171-3.915Zm0,0",
    transform: "translate(0.499 0.5)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoCamera);
export default __webpack_public_path__ + "static/media/video-camera.7e5bbd445cbcc0f3139c50eceb1ab030.svg";
export { ForwardRef as ReactComponent };